import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconBounce = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M19.707 10.707L12 18.414l-5.5-5.5-4.5-4.5L3.414 7l3.793 3.793L12 15.586l6.293-6.293L16 7h6v6l-2.293-2.293z" }, void 0) }, void 0));
const Memo = memo(SvgIconBounce);
export default Memo;
//# sourceMappingURL=IconBounce.js.map